import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import { Select as BsSelect } from 'bs-unified-ui'

const Select = ({
  form,
  field,
  onChange,
  clearable,
  multiple,
  onClear,
  disabled,
  ...props
}) => (
  <BsSelect
    {...field}
    {...props}
    multiple={multiple}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    onChange={(e, action) => {
      if (multiple) {
        if (
          typeof action === 'object' &&
          e.target.value &&
          !(e.target.value || []).includes('button_action')
        ) {
          form.setFieldValue(field.name, e.target.value)
        }
      } else {
        form.setFieldValue(field.name, e.target.value)
        onChange(e.target.value)
      }
    }}
    onClear={
      clearable
        ? () => {
            if (clearable) {
              form.setFieldValue(field.name, '')
              onClear()
            }
          }
        : null
    }
    clearable={clearable}
    {...(multiple
      ? {
          actionOnFocus: () => {
            form.setFieldValue(`backup_${field.name}`, field.value || [])
          },
          actionOnBlur: () => {
            form.setFieldValue(
              field.name,
              form.values[`backup_${field.name}`] || [],
            )
          },
        }
      : {})}
    disabled={disabled || !!form.values.__readOnly}
  />
)

Select.defaultProps = {
  onChange: () => {},
  forwardOptions: (o) => o,
  onClear: () => null,
  clearable: false,
  multiple: false,
  groupByKey: '',
  disabled: false,
}

Select.propTypes = {
  onChange: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  forwardOptions: PropTypes.func,
  onClear: PropTypes.func,
  clearable: PropTypes.bool,
  multiple: PropTypes.bool,
  groupByKey: PropTypes.string,
  disabled: PropTypes.bool,
}

export default Select
